import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "6", x: "9", y: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "6", x: "16", y: "16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "6", x: "2", y: "16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5 16v-4h14v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12V8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Network";
const Network = memo(themed(Icon));
export {
  Network
};
//# sourceMappingURL=network.js.map
